// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2lIbJ","checkboxCol":"Table_checkboxCol__2HmHw","emailCol":"Table_emailCol__2UHiT","actionCol":"Table_actionCol__1VufV"};